import React from "react";
import { FaFilePdf, FaFileAlt, FaEye, FaLayerGroup } from "react-icons/fa"; // Added FaLayerGroup for DWG
import "./FileThumbnail.css";

const FileThumbnail = ({ files }) => {
  if (!files || files.length === 0) return null;

  const getFileType = (url) => {
    if (!url) return "other";
    const extension = url.split(".").pop().toLowerCase();
    
    if (["jpg", "jpeg", "png", "gif"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";
    if (extension === "dwg") return "dwg"; //  Added DWG check
    return "other";
  };

  return (
    <div className="file-thumbnails">
      {files.map((fileUrl, index) => {
        const fileType = getFileType(fileUrl.Location);
        return (
          <div key={index} className="file-thumbnail">
            {fileType === "image" ? (
              <img src={fileUrl.Location} alt="file preview" className="thumbnail-image" />
            ) : fileType === "pdf" ? (
              <FaFilePdf className="thumbnail-icon pdf" />
            ) : fileType === "dwg" ? (
              //  Specific Icon for DWG
              <FaLayerGroup className="thumbnail-icon dwg" style={{ color: "#e34f26" }} /> 
            ) : (
              <FaFileAlt className="thumbnail-icon other" />
            )}
            
            <div className="file-actions">
              <a href={fileUrl.Location} target="_blank" rel="noopener noreferrer" className="action-button">
                <FaEye /> View
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FileThumbnail;